import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, CircularProgress } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import axios from "axios";

export default function BuildingDesign() {
  const [buildingDesigns, setBuildingDesigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBuildingDesigns = async () => {
      try {
        const res = await axios.get("https://urbancasabackendfiles.onrender.com/api/innerProjects?category=Building");
        setBuildingDesigns(res.data);
      } catch (error) {
        console.error("Error fetching building designs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBuildingDesigns();
  }, []);

  return (
    <div>
      <VideoCorousel />
      <Container style={{ padding: "40px",width:"100%" }}>
        <Typography variant="h3" align="center" gutterBottom>
          Building Designs
        </Typography>

        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <Grid container spacing={4} justifyContent="center">

            {buildingDesigns.map((home, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <HomeCard home={home} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </div>
  );
}
